export const SinceOptions = [
  { label: 'All logs', value: 0 },
  { label: 'Last day', value: 24 * 60 * 60 },
  { label: 'Last 4 hours', value: 4 * 60 * 60 },
  { label: 'Last hour', value: 60 * 60 },
  { label: 'Last 10 minutes', value: 10 * 60 },
];
